<div class="container">
  <div class="px-6 py-4 border-b flex items-center header-title">
    <h2 class="title m-0">{{"CHALLENGE-TIME.NEW-SUB-CHALL" | translate}}</h2>
  </div>
  <div class="card p-2">
    <div class="form-row">
      <mat-form-field appearance="fill">
        <mat-label>{{"CHALLENGE-TIME.TITLE" | translate}} {{"GLOBAL.ITA" | translate}}</mat-label>
        <input matInput [(ngModel)]="i18nTitle['IT']" required>
      </mat-form-field>
      <mat-form-field appearance="fill">
        <mat-label>{{"CHALLENGE-TIME.TITLE" | translate}} {{"GLOBAL.ENG" | translate}}</mat-label>
        <input matInput [(ngModel)]="i18nTitle['EN']" required>
      </mat-form-field>
    </div>
    <div class="bottoni">
      <button (click)="confirmClose()" mat-button-base class="m-4">{{"GLOBAL.CLOSE" | translate}}</button>
      <button mat-raised-button [disabled]="!i18nTitle['EN'] || !i18nTitle['IT']" (click)="submit()" class="m-4 bottone-viola">
        {{"GLOBAL.CREATE" | translate}}
      </button>
    </div>
  </div>
</div>

